export default __webpack_public_path__ + "static/media/nucleo-icons.8e954b74.woff";